import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { getRootStore } from "@/stores/RootStore";
import { observer } from "mobx-react-lite";
import { canEditDictionaries } from "@/utils/permissions";
import { canDeleteFromDictionaries } from "@/utils/permissions";
import { message, Modal, Skeleton, Card, Button, Flex } from "antd";
import styles from "@/styles/TechnicianPage.module.less";
import { ArrowLeftOutlined, DeleteOutlined } from "@ant-design/icons";
import { TechnicianForm } from "@/components/TechnicianForm";
export const TechnicianPage = observer(() => {
    const navigate = useNavigate();
    const { technicianId } = useParams();
    const { singleTechnicianStore: store, authStore: { userRole }, } = getRootStore();
    const { technician, loading } = store;
    const canEdit = canEditDictionaries(userRole);
    const canDelete = canDeleteFromDictionaries(userRole);
    useEffect(() => {
        store.init(technicianId);
        return () => {
            store.clearTechnicianData();
        };
    }, [technicianId]);
    const handleBack = () => {
        navigate("/technicians");
    };
    const handleSave = async (values) => {
        const { password, ...employeeData } = values;
        const isNewTechnician = !technician;
        store.saveTechnician(employeeData, password || undefined).then((savedTechnician) => {
            if (savedTechnician) {
                if (isNewTechnician) {
                    message.success("Техник успешно создан");
                    navigate(`/technicians/${savedTechnician.id}`);
                }
                else {
                    message.success("Техник успешно обновлен");
                }
            }
        });
    };
    const handleDeleteOrder = () => {
        if (!technician)
            return;
        Modal.confirm({
            title: "Удаление техника",
            content: "Вы уверены, что хотите удалить этого техника?",
            okText: "Удалить",
            okType: "danger",
            cancelText: "Отмена",
            onOk: async () => {
                await store.deleteTechnician(technician.id);
                message.success("Техник успешно удален");
                handleBack();
            },
        });
    };
    if (loading) {
        return (_jsx("div", { className: styles.container, children: _jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }) }));
    }
    return (_jsxs(Flex, { vertical: true, gap: "large", className: styles.container, children: [_jsx("div", { className: styles.backButtonContainer, children: _jsx(Button, { icon: _jsx(ArrowLeftOutlined, {}), onClick: handleBack, type: "text", className: styles.backButton, children: "\u041D\u0430\u0437\u0430\u0434 \u043A \u0441\u043F\u0438\u0441\u043A\u0443" }) }), _jsx(TechnicianForm, { technician: technician, loading: loading, isNew: !technicianId, onSubmit: handleSave, onCancel: handleBack, disabled: !canEdit, extraButtons: _jsx(_Fragment, { children: canDelete && technician && (_jsx(Button, { danger: true, icon: _jsx(DeleteOutlined, {}), onClick: handleDeleteOrder, children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0442\u0435\u0445\u043D\u0438\u043A\u0430" })) }) })] }));
});
export default TechnicianPage;
